
<script>
import NewForm from './New'
export default {
  mixins: [NewForm],
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$http.get(`/insurance-rates/${this.$route.query.id}`).then(res => {
        this.form = { ...res.data, supplierId: res.data.supplierId || -1 }
      })
    },
    save() {
      this.$http
        .put(`/insurance-rates/${this.$route.query.id}`, {
          ...this.form,
          supplierId: this.form.supplierId === -1 ? null : this.form.supplierId
        })
        .then(() => {
          this.$router.go(-1)
        })
    },
    remove() {
      this.$http.delete(`/insurance-rates/${this.$route.query.id}`).then(() => {
        this.$router.go(-1)
      })
    }
  }
}
</script>
